/** The phase currently being built. Updated at the start of each phase. */
export const CURRENT_PHASE = 'p03';

export interface BuildInfo {
  phase: string;
  /** Short git commit SHA, or "dev" when running locally without one. */
  sha: string;
}

export function formatVersion(info: BuildInfo): string {
  return `${info.phase} · ${info.sha}`;
}

export function shortSha(sha: string | undefined | null): string {
  const trimmed = sha?.trim();
  return trimmed ? trimmed.slice(0, 7) : 'dev';
}
